//import PeopleIcon from '@material-ui/icons/People';
import { Resource, ResourceElement } from 'react-admin';
import List from './list';
import Icon from '@mui/icons-material/LockOpen';
import { getResourcePath } from 'admin/pages-factory';

/**
 * Компонент страницы - Пользователи
 * @param permissions - полученные права доступа
 * @returns - React.Node
 */
 const AccessTokensPage  = (permissions: any): ResourceElement | null => {
  // в упрощенном варианте - пока есть права, рендерим страницу(вкладку) - пользователи
  return permissions
              ? <Resource name= {getResourcePath('access_tokens', 'accounts')}
                          list={List}
                          icon={Icon}
                          options={{label: "Access Tokens"}} />
              : null;
}


export default AccessTokensPage;
